var _style, _text, _text2, _text3, _rect, _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 57.9",
    style: {
      enableBackground: "new 0 0 120 57.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010202;}\r\n\t.st1{font-family:'TimesNewRomanPSMT';}\r\n\t.st2{font-size:14.1977px;}\r\n\t.st3{fill:#7580BE;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#E51F29;}\r\n\t.st5{clip-path:url(#SVGID_2_);fill:#010202;}\r\n\t.st6{clip-path:url(#SVGID_2_);fill:#7580BE;}\r\n")), /*#__PURE__*/React.createElement("g", null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9983 0 0 1 66.4666 9.8672)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st0 st1 st2"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.1,
    y: 0,
    className: "st0 st1 st2"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.83,
    y: 0,
    className: "st0 st1 st2"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.92,
    y: 0,
    className: "st0 st1 st2"
  }, "nn"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.12,
    y: 0,
    className: "st0 st1 st2"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.85,
    y: 0,
    className: "st0 st1 st2"
  }, "ng"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9983 0 0 1 66.4666 24.0933)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st0 st1 st2"
  }, "In"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.83,
    y: 0,
    className: "st0 st1 st2"
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.57,
    y: 0,
    className: "st0 st1 st2"
  }, "tit"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.75,
    y: 0,
    className: "st0 st1 st2"
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.85,
    y: 0,
    className: "st0 st1 st2"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.57,
    y: 0,
    className: "st0 st1 st2"
  }, "e"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9983 0 0 1 66.4666 38.2871)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st3 st1 st2"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.47,
    y: 0,
    className: "st3 st1 st2"
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.57,
    y: 0,
    className: "st3 st1 st2"
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.32,
    y: 0,
    className: "st3 st1 st2"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.04,
    y: 0,
    className: "st3 st1 st2"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.77,
    y: 0,
    className: "st3 st1 st2"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.87,
    y: 0,
    className: "st3 st1 st2"
  }, "li"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.32,
    y: 0,
    className: "st3 st1 st2"
  }, "a"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.01,
    y: 0.11,
    className: "st4",
    width: 61.52,
    height: 57.79
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.01,
    y: 0.11,
    width: 61.52,
    height: 57.79
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7.7,16.89v8.97c0,1.98,0.12,3.15,0.47,3.61c0.47,0.7,1.28,1.05,2.21,1.05h0.93v0.82H0.36v-0.82h0.93 c1.17,0,1.86-0.47,2.33-1.28c0.23-0.47,0.35-1.63,0.35-3.38V5.93c0-1.98-0.12-3.15-0.47-3.61c-0.47-0.7-1.17-1.05-2.21-1.05H0.36 V0.46h9.44c2.21,0,4.08,0.35,5.36,0.93c1.4,0.47,2.45,1.51,3.38,2.8c0.93,1.4,1.4,3.03,1.4,4.78c0,2.56-0.7,4.66-2.1,6.18 c-1.4,1.63-3.26,2.33-5.83,2.33c-0.58,0-1.28,0-1.98-0.12C9.21,17.24,8.51,17.12,7.7,16.89L7.7,16.89z M7.7,15.61 c0.58,0.12,1.28,0.23,1.75,0.35c0.47,0,0.93,0.12,1.28,0.12c1.4,0,2.45-0.7,3.38-1.86c1.05-1.28,1.51-2.8,1.51-4.78 c0-1.28-0.23-2.56-0.7-3.61c-0.47-1.17-1.17-2.1-1.98-2.56c-0.82-0.58-1.75-0.93-2.8-0.93c-0.7,0-1.51,0.23-2.45,0.47V15.61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.21,30.52v0.82H22.26v-0.82h0.82c1.17,0,1.86-0.47,2.33-1.17c0.35-0.47,0.47-1.63,0.47-3.5V5.93 c0-1.51,0-2.56-0.23-3.03c-0.12-0.47-0.35-0.82-0.82-1.05c-0.47-0.35-1.05-0.58-1.75-0.58h-0.82V0.46h10.95v0.82h-0.93 c-1.05,0-1.75,0.47-2.21,1.17c-0.35,0.47-0.47,1.63-0.47,3.5v19.93c0,1.51,0,2.56,0.23,3.15c0.12,0.35,0.35,0.7,0.82,0.93 c0.47,0.35,1.05,0.58,1.63,0.58H33.21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M51.86,21.08h-9.9l-1.75,4.78c-0.47,1.17-0.58,2.1-0.58,2.68c0,0.47,0.12,0.93,0.47,1.28 c0.47,0.35,1.17,0.58,2.45,0.7v0.82H34.5v-0.82c1.05-0.23,1.75-0.58,1.98-0.93c0.7-0.7,1.4-2.21,2.21-4.43l8.97-25.4h0.7 l8.97,25.63c0.7,2.1,1.28,3.38,1.86,4.08c0.58,0.58,1.4,0.93,2.45,1.05v0.82H51.51v-0.82c1.05-0.12,1.75-0.35,2.1-0.7 c0.35-0.35,0.58-0.7,0.58-1.28c0-0.58-0.23-1.63-0.82-3.15L51.86,21.08z M51.28,19.33L46.96,6.98l-4.43,12.35H51.28z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPia);
export default __webpack_public_path__ + "static/media/pia.0278b88ba47266f33eb859ab91d6b138.svg";
export { ForwardRef as ReactComponent };